import Vue from 'vue';

export let store = Vue.observable({
    window: {
        w: null,
        h: null
    },
    getStart: null,
    homeName: {
        ru: 'Творческая студия',
        ua: 'Творча студія',
        en: 'Creative studio'
    },

    contactsLetter: {
        ru: 'Введите текст',
        ua: 'Введіть текст',
        en: 'Enter your text'
    },
    casesWatchProject: {
        ru: 'просмотреть проект',
        ua: 'переглянути проект',
        en: 'view project'
    },
    learnMoreBTN: {
        ru: 'Больше',
        en: 'Learn More',
        ua: 'Більше'
    },
    navHome: {
        ru: 'ГЛАВНАЯ',
        ua: 'ГОЛОВНА',
        en: 'HOME'
    },
    navService: {
        ru: 'УСЛУГИ',
        ua: 'ПОСЛУГИ',
        en: 'SERVICES'
    },
    navCases: {
        ru: 'КЕЙСЫ',
        ua: 'КЕЙСИ',
        en: 'CASES'
    },
    navContacts: {
        ru: 'КОНТАКТЫ',
        ua: ' КОНТАКТИ',
        en: 'CONTACTS'
    },
    copyMail: {
        ru: 'Скопировано в буфер обмена',
        en: 'Copied to clipboard',
        ua: 'Скопійовано до буферу обміну'
    }
})



// WEBPACK FOOTER //
// ./src/store.js